import React, { useRef } from "react";
import { Button } from "@/components/ui/button";

export function FilePickButton({ accept, onFile, children, testId, disabled, className = "", variant = "outline", size = "sm", title }) {
  const inputRef = useRef(null);
  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className="hidden"
        onChange={(e) => { const file = e.target.files?.[0]; e.target.value = ""; if (file) onFile(file); }}
        data-testid={`${testId}-input`}
      />
      <Button type="button" variant={variant} size={size} className={className} disabled={disabled} title={title} onClick={() => inputRef.current?.click()} data-testid={testId}>
        {children}
      </Button>
    </>
  );
}
